import React from 'react';
import { FaEye, FaArrowRight } from 'react-icons/fa';
import {
  Card,
  Header,
  IconWrapper,
  MappingInfo,
  MappingRow,
  ValuePreviewWrapper
} from './styles';
import { Badge } from 'reactstrap';

export const ValuePreview = ({
  selectedFieldInfo,
  autoMappingPrevField,
  availablePrevCustomFields,
  parseValuesByType
}) => {
  if (!selectedFieldInfo.name || !autoMappingPrevField) return null;

  const prevField = availablePrevCustomFields.find(
    (field) => field.id === autoMappingPrevField
  );
  if (!prevField) return null;

  const previewValue = parseValuesByType(prevField.value, prevField.type);

  const formatPreviewValue = (value, type) => {
    if (value == null) return '';

    switch (type) {
      case 'DATE':
        return value instanceof Date && !isNaN(value)
          ? value.toLocaleDateString('pt-BR', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            })
          : '';
      case 'BOOLEAN':
        return value ? 'Sim' : 'Não';
      case 'NUMBER':
        return isNaN(value) ? '' : value.toString();
      default:
        return value.toString();
    }
  };

  return (
    <Card>
      <Header>
        <IconWrapper>
          <FaEye />
        </IconWrapper>
        <h6>Preview do Mapeamento</h6>
      </Header>

      <MappingRow>
        <MappingInfo>
          <Badge variant="origin">{prevField.label}</Badge>
          <FaArrowRight size={14} color="#868e96" />
          <Badge variant="destination">{selectedFieldInfo.name}</Badge>
        </MappingInfo>

        <ValuePreviewWrapper>
          <small>Valor:</small>
          <Badge variant="value">
            {formatPreviewValue(previewValue, prevField.type)}
          </Badge>
        </ValuePreviewWrapper>
      </MappingRow>
    </Card>
  );
};
